import React from 'react';
import Header from "./../components/Header";
// import Box from "./../components/3d/Box";
// import {useContext} from "react";
// import {PortfolioContext} from '../context';
export default function Home(){
    return(
        <section>
            {/* <Box/> */}
            <Header/>
        </section>  
    )
}